import endpoints from 'config/endpoints';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';

import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE} from 'util/constants';

const MONTHS_START = 12;
const MONTHS_END = 1;
const LAST_DATE = 0;
const FIRST_DATE = 1;

module.exports = storeModuleFactory({
    name:            'reportingLast13MonthsBackups',
    endpoint:        endpoints.reportingBackupsMonthlyAggr.endpoint,
    timeout:         TIMEOUT_STORE.TIMEOUT_STORE_BIG,
    filterParamsMap: {
        startDate: 'start_date',
        endDate:   'end_date'
    },
    parseParameters: ({selectedHosts}) => {
        const endDate = new Date();

        endDate.setMonth(endDate.getMonth() + MONTHS_END);
        endDate.setDate(LAST_DATE);
        const startDate = new Date(endDate);

        startDate.setMonth(startDate.getMonth() - MONTHS_START);
        startDate.setDate(FIRST_DATE);

        return {
            start_date: Math.floor(startDate / TIMESTAMP_MULTIPLY),
            end_date:   Math.floor(endDate / TIMESTAMP_MULTIPLY),
            host:       selectedHosts
        };
    },
    transformResultsFn:  json => json,
    transformEntitiesFn: item => ({
        date:       item.date * TIMESTAMP_MULTIPLY,
        backupSize: item.backup_size
    })
});



// WEBPACK FOOTER //
// ./src/modules/store/reportingLast13MonthsBackups.js